import React, { useState, useEffect } from 'react';
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess } from 'components/user-access';
import { LicenceCheckingService, EmployeeService } from 'services';
import { NotificationToaster, NotificationInline } from 'components/notifications';
import { Intent } from '@blueprintjs/core';
import axios from 'axios';
import { Breadcrumbs } from 'components/navigation';
import { LicenceCheckingPolicyWizard } from "pages/licence-checking/policies/shared"
import { useParams } from 'react-router-dom';
import { ShowHide } from 'components/layout';
import { LinkButton } from 'components/buttons';
import moment from "moment";

export function LicenceCheckingPolicyEdit(props) {

    const { id } = useParams();
    const requiredAction = "LicenceChecking:Manage";
    const [loading, setLoading] = useState(true);

    const [policy, setPolicy] = useState({});
    const [employeeOptions, setEmployeeOptions] = useState({});
    const [licenceCheckingOptions, setLicenceCheckingOptions] = useState({});
    const [credits, setCredits] = useState(0);
    const [invalidPolicy, setInvalidPolicy] = useState(false);
    const reoccurrenceRepeatOptions = [
        { name: "Days", id: "D", daysBetweenChecks: 1 },
        { name: "Weeks", id: "W", daysBetweenChecks: 7 },
        { name: "Months", id: "M", daysBetweenChecks: 30.4 },
    ]

    useEffect(() => {
        var errorHandler = function (error) {
            const noAccessCode = 403;

            if (error?.response?.status === noAccessCode) {
                setInvalidPolicy(true);
            }
            NotificationToaster.show(Intent.DANGER, "Failed to obtain credit estimate. Please try again.");
        }

        axios.all([LicenceCheckingService.getPolicy(id), EmployeeService.getEmployeeOptions(), LicenceCheckingService.getLicenceCheckingOptions(), LicenceCheckingService.getCredits()])
            .then(axios.spread(function (getPolicyResponse, getEmployeeOptionsResponse, getLicenceCheckingOptionsResponse, getCreditsResponse) {
                setupPolicy(getPolicyResponse, getEmployeeOptionsResponse, getLicenceCheckingOptionsResponse.policyRules)
                setPolicy(getPolicyResponse);
                getEmployeeOptionsResponse.employeeStatuses = getEmployeeOptionsResponse.employeeStatuses.filter(c => c.name.toLowerCase() !== "inactive");
                getLicenceCheckingOptionsResponse.policyRules = getLicenceCheckingOptionsResponse.policyRules.filter(c => c.key.toLowerCase() !== "base");
                setEmployeeOptions(getEmployeeOptionsResponse);
                setLicenceCheckingOptions(getLicenceCheckingOptionsResponse);
                setCredits(getCreditsResponse.licenceCredits);
            }), errorHandler).catch((error) => {
                errorHandler(error)
            }).finally(() => {
                setLoading(false);
            });

    }, []);

    function remapEmployee(policyValues, lookupList) {
        let mappedSettings = [];
        if (policyValues) {
            policyValues.forEach(e => {
                let option = lookupList.find(o => o.id === e);
                mappedSettings.push(option);
            });
        }
        return mappedSettings;
    }

    function setupPolicy(policyResp, employeeOptionsResp, policyRules) {
        policyResp.id = id;
        policyResp.employeeTypes = remapEmployee(policyResp.employeeTypes, employeeOptionsResp.employeeTypes);
        policyResp.employeeCategories = remapEmployee(policyResp.employeeCategories, employeeOptionsResp.employeeCategories);
        policyResp.employeeStatuses = remapEmployee(policyResp.employeeStatuses, employeeOptionsResp.employeeStatuses);
        policyResp.checkFrequencyType = reoccurrenceRepeatOptions.find(f => f.id === policyResp.checkFrequencyType);
        policyResp.startDate = moment(policyResp.startDate).format("YYYY-MM-DD");
        if (policyResp.advancedRules) {
            policyResp.advancedRules = policyResp.advancedRules.map(r => {
                return {
                    rule: policyRules.find(p => p.id === r.policyRuleId),
                    threshold: r.ruleThreshold,
                    checkFrequency: r.checkFrequency,
                    checkFrequencyType: reoccurrenceRepeatOptions.find(f => f.id === r.checkFrequencyType)
                }
            });
        }
    }

    return (

        <UserAccess perform={requiredAction}
            yes={() => (
                <ShowHide
                    evaluator={invalidPolicy}
                    show={(
                        <div className="row">
                            <Breadcrumbs items={props.breadcrumbs} />
                            <NotificationInline
                                allowClose={false}
                                show
                                text="You do not have permission to view this policy"
                                intent="danger">
                            </NotificationInline>
                            <div>
                                <LinkButton intent="primary" text="Back to Licence Checking Policies" id="listing-user" href="/licence-checking/policies" />
                            </div>
                        </div>
                    )}
                    hide={(

                        <div className="row">
                            <Breadcrumbs items={props.breadcrumbs} />
                            <h1>Edit Licence Checking Policy</h1>

                            <LicenceCheckingPolicyWizard
                                loading={loading}
                                policy={policy}
                                employeeOptions={employeeOptions}
                                licenceCheckingOptions={licenceCheckingOptions}
                                credits={credits}
                                createPolicy={false}
                            />
                        </div>
                    )}
                />
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}